<template>
  <div
    class="tw-grid tw-grid-cols-[repeat(auto-fill,minmax(20rem,1fr))] tw-gap-3"
  >
    <slot />
  </div>
</template>
